"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.decodeUrlCriteria = exports.encodeUrlCriteria = void 0;
/**
 *
 * A function to encode criteria object so that they can be used in a url string.
 * The encodeUrlCriteria is intended used together with decodeUrlCriteria
 *
 * @example
 *
 * ```typescript
 * import { encodeUrlCriteria } from "@mne-core/providers/Target";
 *
 * const myEncodedCriteriaString = encodeUrlCriteria({ a: 1, b: { c: "hello"} });
 * ```
 *
 * @param criteria A criteria object
 * @returns The encoded object. It can be decoded with decodeUrlCriteria
 */
function encodeUrlCriteria(criteria) {
    return btoa(encodeURIComponent(JSON.stringify(criteria)));
}
exports.encodeUrlCriteria = encodeUrlCriteria;
/**
 *
 * A function to decode criteria object from a url string.
 * The decodeUrlCriteria is intended used together with encodeUrlCriteria
 *
 * @example
 *
 * ```typescript
 * import { decodeUrlCriteria } from "@mne-core/providers/Target";
 *
 * const myCriteria = decodeUrlCriteria(myEncodedString);
 * ```
 *
 * @param criteria A criteria object
 * @returns The encoded object. It can be decoded with decodeUrlCriteria
 */
function decodeUrlCriteria(s) {
    return JSON.parse(decodeURIComponent(atob(s)));
}
exports.decodeUrlCriteria = decodeUrlCriteria;
